<template>
  <div>
    <Rsljigou v-if="processingMode == 1 && SubRule_Optometrist_DaiKeXiaDan" :propsjigouid="myForm.daikexiadanjigouid" :propsjigouname="myForm.daikexiadanjigouname" @change="changeRsljigou"></Rsljigou>
    <table border='0' cellpadding='0' cellspacing='0' width='1096' style='border-collapse:
     collapse;table-layout:fixed;width:822pt'>
     <col class='x69' width='137' span='8' style='mso-width-source:userset;width:102.75pt'>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r0'>
    <td colspan='8' rowspan='2' height='78' class='x70' width='1096' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:58.5pt;'>配镜处方单</td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r1'>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r2'>
    <td height='38' class='x71' style='height:28.5pt;'>姓名</td>
    <td class='x72'><input type="text" v-model="myForm.username"/></td>
    <td class='x71'>性别</td>
    <td class='x72'>
      <el-radio v-model="myForm.sex" label="男">男</el-radio>
      <el-radio v-model="myForm.sex" label="女">女</el-radio>
    </td>
    <td class='x71'>年龄</td>
    <td class='x72'><input type="text" v-model="myForm.age"/></td>
    <td class='x71'>配镜时间</td>
    <td class='x72'>
      <el-date-picker style="width:100%" v-model="myForm.glassestime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
      </el-date-picker>
    </td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r3'>
    <td rowspan='4' height='158' class='x71' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:118.5pt;'>地址</td>
    <td class='x73'>收货人</td>
    <td colspan='6' class='x74' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <input type="text" v-model="myForm.consignee"/>
    </td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r4'>
    <td class='x73'>手机号码</td>
    <td colspan='6' class='x74' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
    <input type="text" v-model="myForm.phone"/>
    </td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r5'>
    <td class='x73'>省市区</td>
    <td colspan='6' class='x74' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <el-select v-model="myForm.provinces" placeholder="请选择省" @change="changeprovince()">
         <el-option
           v-for="item in OptionsProvince"
           :key="item.value"
           :label="item.label"
           :value="item.value"
         >
         </el-option>
       </el-select>
       <el-select v-model="myForm.cities" placeholder="请选择市" @change="changecity()">
         <el-option
           v-for="item in OptionsCity"
           :key="item.value"
           :label="item.label"
           :value="item.value"
         >
         </el-option>
       </el-select>
       <el-select v-model="myForm.districts" placeholder="请选择区">
         <el-option
           v-for="item in OptionsArea"
           :key="item.value"
           :label="item.label"
           :value="item.value"
         >
         </el-option>
       </el-select>
    </td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r6'>
    <td class='x75'>详细地址</td>
    <td colspan='6' class='x74' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <input type="text" v-model="myForm.consigneeaddress"/>
    </td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r7'>
    <td colspan='8' height='38' class='x76' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:28.5pt;'>配镜处方</td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r8'>
    <td colspan='2' height='38' class='x71' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:28.5pt;'></td>
    <td class='x71'>球镜</td>
    <td class='x71'>柱镜</td>
    <td class='x71'>轴位</td>
    <td class='x71'>矫正视力</td>
    <td class='x71'>瞳距(mm)</td>
    <td class='x71'>瞳高(mm)</td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r9'>
    <td rowspan='2' height='78' class='x71' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:58.5pt;'>远用</td>
    <td class='x71'>R</td>
    <td class='x72'><input type="text" v-model="myForm.eyedegreefarright"/></td>
    <td class='x72'><input type="text" v-model="myForm.columnmirrorfarright" @input="handleInput"/></td>
    <td class='x72'><input type="text" v-model="myForm.axialfarright"/></td>
    <td class='x72'><input type="text" v-model="myForm.correctdegreefarright"/></td>
    <td class='x72'><input type="text" v-model="myForm.interpupillaryfarright"/></td>
    <td class='x72'><input type="text" v-model="myForm.pupilheightfarright"/></td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r10'>
    <td class='x71'>L</td>
    <td class='x72'><input type="text" v-model="myForm.eyedegreefarleft"/></td>
    <td class='x72'><input type="text" v-model="myForm.columnmirrorfarleft" @input="handleInput"/></td>
    <td class='x72'><input type="text" v-model="myForm.axialfarleft"/></td>
    <td class='x72'><input type="text" v-model="myForm.correctdegreefarleft"/></td>
    <td class='x72'><input type="text" v-model="myForm.interpupillaryfarleft"/></td>
    <td class='x72'><input type="text" v-model="myForm.pupilheightfarleft"/></td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r11'>
    <td rowspan='2' height='78' class='x71' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:58.5pt;'>近用</td>
    <td class='x71'>R</td>
    <td class='x72'><input type="text" v-model="myForm.eyedegreenearright"/></td>
    <td class='x72'><input type="text" v-model="myForm.columnmirrornearright" @input="handleInput"/></td>
    <td class='x72'><input type="text" v-model="myForm.axialnearright"/></td>
    <td class='x72'><input type="text" v-model="myForm.correctdegreenearright"/></td>
    <td class='x72'><input type="text" v-model="myForm.interpupillarynearright"/></td>
    <td class='x72'><input type="text" v-model="myForm.pupilheightnearright"/></td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r12'>
    <td class='x71'>L</td>
    <td class='x72'><input type="text" v-model="myForm.eyedegreenearleft"/></td>
    <td class='x72'><input type="text" v-model="myForm.columnmirrornearleft" @input="handleInput"/></td>
    <td class='x72'><input type="text" v-model="myForm.axialnearleft"/></td>
    <td class='x72'><input type="text" v-model="myForm.correctdegreenearleft"/></td>
    <td class='x72'><input type="text" v-model="myForm.interpupillarynearleft"/></td>
    <td class='x72'><input type="text" v-model="myForm.pupilheightnearleft"/></td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r13'>
    <td height='38' class='x71' style='height:28.5pt;'>是否散瞳</td>
    <td class='x72'>
      <el-radio v-model="myForm.isspecialized" label="是">是</el-radio>
      <el-radio v-model="myForm.isspecialized" label="否">否</el-radio>
    </td>
    <td class='x71'>通道</td>
    <td class='x72'><input type="text" v-model="myForm.channel"/></td>
    <td class='x71'>ADD</td>
    <td class='x72'>
      <el-select v-model="myForm.addtype" placeholder="请选择">
        <el-option
          v-for="item in AddTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </td>
    <td class='x71'>验光日期</td>
    <td class='x72'>
      <el-date-picker style="width:100%" v-model="myForm.optometrytime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
      </el-date-picker>
    </td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r14'>
    <td height='38' class='x71' style='height:28.5pt;'>备注</td>
    <td colspan='5' class='x72' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <input type="text" v-model="myForm.remarks"/>
    </td>
    <td class='x71'>验光师</td>
    <td class='x72'>
      <input type="text" v-model="myForm.optometryname"/>
    </td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r15'>
    <td colspan='5' height='38' class='x71' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:28.5pt;'>商品名称</td>
    <td class='x71'>数量</td>
    <td class='x71'>单价/元</td>
    <td class='x71'>金额/元</td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r16'>
    <td height='38' class='x71' style='height:28.5pt;'>镜架</td>
    <td colspan='4' class='x72' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <el-select style="width: 33%;" v-model="myForm.framebrand" placeholder="请选择品牌" @change="selectchangeJingJia1()">
        <el-option
          v-for="item in FrameBrandOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select style="width: 33%;" v-model="myForm.frameproductname" filterable placeholder="请选择商品名称" @change="selectchangeJingJia2()">
        <el-option
          v-for="item in FrameProductNameOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select style="width: 33%;" v-model="myForm.framespecifications" filterable placeholder="请选择规格型号" @change="selectchangeJingJia3()">
        <el-option
          v-for="item in FrameSpecificationsOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </td>
    <td class='x72'><input type="text" :change="processData()" v-model="myForm.framenum"/></td>
    <td class='x77'><input type="text" :change="processData()" v-model="myForm.framepriceForDisplay" disabled/></td>
    <td rowspan='7' height='238' class='x78' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;height:178.5pt;'>
      <input type="text" v-model="myForm.amountForDisplay" disabled/>
    </td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r17'>
    <td height='38' class='x71' style='height:28.5pt;'>镜片</td>
    <td colspan='4' class='x72' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <el-select style="width: 33%;" v-model="myForm.lensbrand" placeholder="请选择品牌" @change="selectchangeJingPian1()">
        <el-option
          v-for="item in LensBrandOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select style="width: 33%;" v-model="myForm.lensproductname" filterable placeholder="请选择商品名称" @change="selectchangeJingPian2()">
        <el-option
          v-for="item in LensProductNameOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select style="width: 33%;" v-model="myForm.lensspecifications" filterable placeholder="请选择规格型号" @change="selectchangeJingPian3()">
        <el-option
          v-for="item in LensSpecificationsOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </td>
    <td class='x72'><input type="text" :change="processData()" v-model="myForm.lensnum"/></td>
    <td class='x77'><input type="text" :change="processData()" v-model="myForm.lenspriceForDisplay" disabled/></td>
     </tr>

    <tr height='40' style='mso-height-source:userset;height:30pt' id='r17'>
    <td height='38' class='x71' style='height:28.5pt;'>备用镜片</td>
    <td colspan='4' class='x72' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <el-select style="width: 33%;" v-model="myForm.lensReservebrand" placeholder="请选择品牌" @change="selectchangeReserveJingPian1()">
        <el-option
          v-for="item in LensReserveBrandOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select style="width: 33%;" v-model="myForm.lensReserveproductname" filterable placeholder="请选择商品名称" @change="selectchangeReserveJingPian2()">
        <el-option
          v-for="item in LensReserveProductNameOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select style="width: 33%;" v-model="myForm.lensReservespecifications" filterable placeholder="请选择规格型号" @change="selectchangeReserveJingPian3()">
        <el-option
          v-for="item in LensReserveSpecificationsOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </td>
    <td class='x72'><input type="text" :change="processData()" v-model="myForm.lensReservenum"/></td>
    <td class='x77'><input type="text" :change="processData()" v-model="myForm.lensReservepriceForDisplay" disabled/></td>
     </tr>

    <tr height='40' style='mso-height-source:userset;height:30pt' id='r18'>
    <td height='38' class='x71' style='height:28.5pt;'>保险费</td>
    <td colspan='4' class='x72' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <el-select v-model="myForm.insurancename" placeholder="请选择是否购买保险" @change="selectchangeInsurance()">
        <el-option label="我需要购买3年保险" value="我需要购买保险"></el-option>
        <el-option label="我不需要购买保险" value="我不需要购买保险"></el-option>
      </el-select>
    </td>
    <td class='x79'><input type="text" :change="processData()" v-model="myForm.insurancenum" :disabled="disableEditNum"/></td>
    <td class='x77'><input type="text" :change="processData()" v-model="myForm.insuranceprice" disabled/></td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r19'>
    <td height='38' class='x71' style='height:28.5pt;'>加急费</td>
    <td colspan='4' class='x72' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <el-select v-model="myForm.isurgent" placeholder="请选择是否加急" @change="selectchangeUrgent()">
        <el-option label="不加急" value="不加急"></el-option>
        <el-option label="加急" value="加急"></el-option>
      </el-select>
    </td>
    <td class='x79'><input type="text" :change="processData()" v-model="myForm.urgentnum" disabled/></td>
    <td class='x77'><input type="text" :change="processData()" v-model="myForm.urgentprice" disabled/></td>
     </tr>
     <tr height='40' style='mso-height-source:userset;height:30pt' id='r20'>
    <td height='38' class='x71' style='height:28.5pt;'>加工费</td>
    <td colspan='4' class='x79' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
      <input type="text" v-model="myForm.processcostname" disabled/>
    </td>
    <td class='x79'><input type="text" :change="processData()" v-model="myForm.processcostnum" :disabled="disableEditNum"/></td>
    <td class='x77'><input type="text" :change="processData()" v-model="myForm.processcostprice" disabled/></td>
     </tr>
    <tr height='40' style='mso-height-source:userset;height:30pt' id='r21'>
      <td height='38' class='x71' style='height:28.5pt;'>礼品</td>
      <td colspan='4' class='x79' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
        <input type="text" v-model="lipin" disabled/>
      </td>
      <td class='x79'></td>
      <td class='x77'></td>
    </tr>
    <tr height='40' style='mso-height-source:userset;height:50pt' id='r21'>
      <td height='38' class='x71' style='height:28.5pt;'>附件</td>
      <td colspan='4' class='x79' style='border-right:1px solid windowtext;border-bottom:1px solid windowtext;'>
        <TencentyunCosUploadMultiImg ref="MultiImg" @change="addTencentyunCosUploadMultiImg"></TencentyunCosUploadMultiImg>
      </td>
      <td class='x79'></td>
      <td class='x77'></td>
      <td class='x77'></td>
    </tr>
    </table>
    <div class="addbutton">
      <el-button type="primary" v-if="processingMode == 1" @click="clickAdd">添加</el-button>
      <el-button type="primary" v-if="processingMode == 3" @click="clickModify">修改</el-button>
      <el-button type="info" @click="clickBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import TencentyunCosUploadMultiImg from '@/components/TencentyunCosUploadMultiImg.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    TencentyunCosUploadMultiImg
  },
  data() {
    return {
      lipin: "镜盒，镜布，免运费。",
      fullscreenloading: false,
      myForm:{
        orderid: "",
        username: "",
        sex: "",
        age: "",
        glassestime: "",
        consignee: "",
        phone: "",
        provinces: "",
        cities: "",
        districts: "",
        consigneeaddress: "",
        eyedegreefarright: "",
        eyedegreefarleft: "",
        eyedegreenearright: "",
        eyedegreenearleft: "",
        columnmirrorfarright: "",
        columnmirrorfarleft: "",
        columnmirrornearright: "",
        columnmirrornearleft: "",
        axialfarright: "",
        axialfarleft: "",
        axialnearright: "",
        axialnearleft: "",
        correctdegreefarright: "",
        correctdegreefarleft: "",
        correctdegreenearright: "",
        correctdegreenearleft: "",
        interpupillaryfarright: "",
        interpupillaryfarleft: "",
        interpupillarynearright: "",
        interpupillarynearleft: "",
        pupilheightfarright: "",
        pupilheightfarleft: "",
        pupilheightnearright: "",
        pupilheightnearleft: "",
        isspecialized: "",
        channel: "",
        addtype: "",
        optometrytime: "",
        remarks: "",
        optometryname: "",
        ////////////////// 商品信息
        /////////////// 镜架
        framebrand: "",
        frameproductname: "",
        framespecifications: "",
        framenum: "1",
        // 代理商单价
        frameprice: "0",
        // 零售单价
        frameretailprice: "0",
        // 单价字符串
        framepriceForDisplay: "0",
        /////////////// 镜片
        lensbrand: "",// 品牌
        lensproductname: "",// 名称
        lensspecifications: "",// 规格型号
        lensnum: "1",// 数量
        lensprice: "0",// 代理商单价
        lensretailprice: "0",// 零售单价
        lenspriceForDisplay: "0",// 单价字符串
        /////////////// 备用镜片
        lensReservebrand: "",// 品牌
        lensReserveproductname: "",// 名称
        lensReservespecifications: "",// 规格型号
        lensReservenum: "0",// 数量
        lensReserveprice: "0",// 代理商单价
        lensReserveretailprice: "0",// 零售单价
        lensReservepriceForDisplay: "0",// 单价字符串
        /////////////// 加工费
        processcostname: "自动核算",
        processcostnum: "0",
        processcostprice: "0",
        /////////////// 加急费
        isurgent: "不加急",
        urgentnum: "0",
        urgentprice: "0",
        /////////////// 保险费
        insurancename: "我不需要购买保险",
        insurancenum: "0",
        insuranceprice: "0",
        /////////////// 总价
        // 代理商总价
        amount: "0",
        // 零售总价
        amountretail: "0",
        // 总价字符串
        amountForDisplay: "0",
        /////////////// 附件
        attachment: "",
        daikexiadanjigouid: "0",
        daikexiadanjigouname: "",
      },
      myFormBack: [],
      AddTypeOptions: [],
      FrameBrandOptions: [],
      FrameProductNameOptions: [],
      FrameSpecificationsOptions: [],
      LensBrandOptions: [],
      LensProductNameOptions: [],
      LensSpecificationsOptions: [],
      //备用镜片
      LensReserveBrandOptions: [],
      LensReserveProductNameOptions: [],
      LensReserveSpecificationsOptions: [],
      //1添加;2查看;3修改
      processingMode: 1,
      OptionsProvince: [],
      OptionsCity: [],
      OptionsArea: [],
      disableEditNum: true,
      SubRule_Optometrist_ShowPrice: false,
      SubRule_Optometrist_DaiKeXiaDan: false
    };
  },
  mounted () {
  },
  methods: {
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    changeRsljigou (vid, vname) {
      this.myForm.daikexiadanjigouid = vid
      this.myForm.daikexiadanjigouname = vname
    },
    handleInput(event) {
      var value = event.target.value;
      console.log('当前输入的值是:', value);
      //去掉空格,D,d
      //然后判断是否等于0.25或者-0.25
      value = value.replace(/ /g, "");
      value = value.replace(/D/g, "");
      value = value.replace(/d/g, "");
      console.log('处理后的值:', value);
      if(value=="0.25" || value=="-0.25"){
        Vue.prototype.FunAlertMsg('车房片')
      }
    },
    addTencentyunCosUploadMultiImg (url) {
      console.log(url)
      this.myForm.attachment = url
    },
    clickAdd () {
      this.$confirm('您确定需要提交订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiAddOptometristPrescriptions()
      })
    },
    clickModify () {
      this.apiEditOptometristPrescriptions()
    },
    InitData(ShowPrice,DaiKeXiaDan){
      this.SubRule_Optometrist_ShowPrice = ShowPrice
      this.SubRule_Optometrist_DaiKeXiaDan = DaiKeXiaDan
      this.myFormBack = Vue.prototype.CloneObj(this.myForm)
      this.AddTypeOptions = Vue.prototype.FunGetAddType()
      this.apiGetOptometristSuppliersClassification(1,"镜架","","")
      this.apiGetOptometristSuppliersClassification(1,"镜片","","")
      this.apiGetOptometristSuppliersClassification(1,"备用镜片","","")
      this.apiGetOptometristPrescriptionsLastAddress()
      this.apigetregionlist(1, 1)
      this.$refs.MultiImg.InitData()
    },
    ViewData(row,ShowPrice){
      this.SubRule_Optometrist_ShowPrice = ShowPrice
      this.processingMode = 2
      this.myForm.orderid = row.Orderid
      this.AddTypeOptions = Vue.prototype.FunGetAddType()
      this.apiGetOptometristPrescriptionsInfo(row.Orderid)
      this.apigetregionlist(1, 1)
      this.$refs.MultiImg.viewData(row)
    },
    ModifyData(row,ShowPrice){
      this.SubRule_Optometrist_ShowPrice = ShowPrice
      this.processingMode = 3
      this.disableEditNum = false
      this.myForm.orderid = row.Orderid
      this.AddTypeOptions = Vue.prototype.FunGetAddType()
      this.apiGetOptometristPrescriptionsInfo(row.Orderid)
      this.apiGetOptometristSuppliersClassification(1,"镜架","","")
      this.apiGetOptometristSuppliersClassification(1,"镜片","","")
      this.apiGetOptometristSuppliersClassification(1,"备用镜片","","")
      this.apigetregionlist(1, 1)
      this.$refs.MultiImg.viewData(row)
    },
    processData (){
      if(this.processingMode == 1 || this.processingMode == 3){
        //选择“我需要购买保险”时，保险费的数量与镜片的数量一样。
        //选择“我不需要购买保险”时，保险费的数量为0。
        if(this.myForm.insurancename == "我需要购买保险"){
          this.myForm.insurancenum = Number(this.myForm.lensnum) + Number(this.myForm.lensReservenum)
        } else {
          this.myForm.insurancenum = '0'
        }
        //加工费的数量与镜片的数量一样。
        this.myForm.processcostnum = Number(this.myForm.lensnum) + Number(this.myForm.lensReservenum)
      }

      var frameamount = Number(this.myForm.framenum) * Number(this.myForm.frameprice)
      var frameamountretail = Number(this.myForm.framenum) * Number(this.myForm.frameretailprice)

      var lensamount = Number(this.myForm.lensnum) * Number(this.myForm.lensprice)
      var lensamountretail = Number(this.myForm.lensnum) * Number(this.myForm.lensretailprice)

      var lensReserveamount = Number(this.myForm.lensReservenum) * Number(this.myForm.lensReserveprice)
      var lensReserveamountretail = Number(this.myForm.lensReservenum) * Number(this.myForm.lensReserveretailprice)

      var processcostamount = Number(this.myForm.processcostnum) * Number(this.myForm.processcostprice)
      var urgentamount = Number(this.myForm.urgentprice)
      var insuranceamount = Number(this.myForm.insurancenum) * Number(this.myForm.insuranceprice)

      this.myForm.amount = this.pnum(frameamount+lensamount+lensReserveamount+urgentamount+processcostamount+insuranceamount)
      this.myForm.amountretail = this.pnum(frameamountretail+lensamountretail+lensReserveamountretail+urgentamount+processcostamount+insuranceamount)
      if(this.SubRule_Optometrist_ShowPrice){
        //老板权限
        this.myForm.amountForDisplay = ""+this.myForm.amount+"(零售价:"+this.myForm.amountretail+")"
      } else {
        //店员权限
        this.myForm.amountForDisplay = "零售价:"+this.myForm.amountretail
      }
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    },
    selectchangeJingJia1(){
      this.FrameProductNameOptions = []
      this.FrameSpecificationsOptions = []
      this.myForm.frameproductname = ""
      this.myForm.framespecifications = ""
      this.apiGetOptometristSuppliersClassification(2,"镜架",this.myForm.framebrand,"")
    },
    selectchangeJingJia2(){
      this.FrameSpecificationsOptions = []
      this.myForm.framespecifications = ""
      this.apiGetOptometristSuppliersClassification(3,"镜架",this.myForm.framebrand,this.myForm.frameproductname)
    },
    selectchangeJingJia3(){
      this.apiGetOptometristProductinPrice("镜架",this.myForm.framebrand,this.myForm.frameproductname,this.myForm.framespecifications)
      this.apiGetOptometristProcessCost()
    },
    selectchangeJingPian1(){
      this.LensProductNameOptions = []
      this.LensSpecificationsOptions = []
      this.myForm.lensproductname = ""
      this.myForm.lensspecifications = ""
      this.apiGetOptometristSuppliersClassification(2,"镜片",this.myForm.lensbrand,"")
    },
    selectchangeJingPian2(){
      this.LensSpecificationsOptions = []
      this.myForm.lensspecifications = ""
      this.apiGetOptometristSuppliersClassification(3,"镜片",this.myForm.lensbrand,this.myForm.lensproductname)
    },
    selectchangeJingPian3(){
      this.apiGetOptometristProductinPrice("镜片",this.myForm.lensbrand,this.myForm.lensproductname,this.myForm.lensspecifications)
      this.apiGetOptometristProcessCost()
    },
    selectchangeReserveJingPian1(){
      this.LensReserveProductNameOptions = []
      this.LensReserveSpecificationsOptions = []
      this.myForm.lensReserveproductname = ""
      this.myForm.lensReservespecifications = ""
      this.apiGetOptometristSuppliersClassification(2,"备用镜片",this.myForm.lensReservebrand,"")
    },
    selectchangeReserveJingPian2(){
      this.LensReserveSpecificationsOptions = []
      this.myForm.lensReservespecifications = ""
      this.apiGetOptometristSuppliersClassification(3,"备用镜片",this.myForm.lensReservebrand,this.myForm.lensReserveproductname)
    },
    selectchangeReserveJingPian3(){
      this.apiGetOptometristProductinPrice("备用镜片",this.myForm.lensReservebrand,this.myForm.lensReserveproductname,this.myForm.lensReservespecifications)
      this.apiGetOptometristProcessCost()
    },
    selectchangeInsurance(){
      if(this.myForm.insurancename == "我需要购买保险"){
        this.apiGetOptometristProcessCost()
        this.myForm.insurancenum = Number(this.myForm.lensnum) + Number(this.myForm.lensReservenum)
      } else {
        this.myForm.insurancenum = '0'
      }
    },
    selectchangeUrgent(){
      if(this.myForm.isurgent == "加急"){
        if(this.myForm.provinces.length == 0){
          Vue.prototype.FunAlertMsg("请选择省")
          this.myForm.isurgent = "不加急"
          return
        } else {
          this.apiGetOptometristUrgentFee()
        }
      } else {
        this.myForm.urgentnum = '0'
        this.myForm.urgentprice = '0'
      }
    },
    changeprovince (data) {
      this.apigetregionlist(2, this.myForm.provinces)
      if(this.myForm.isurgent == "加急"){
        this.apiGetOptometristUrgentFee()
      }
    },
    changecity (data) {
      this.apigetregionlist(3, this.myForm.cities)
    },
    apigetregionlist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: parentid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getregionlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            if (type == 1) {
              that.OptionsProvince = []
              response.data.List.filter((item, i) => {
                that.OptionsProvince.push({ value: item.Id, label: item.Name })
              })
            }
            if (type == 2) {
              that.OptionsCity = []
              response.data.List.filter((item, i) => {
                that.OptionsCity.push({ value: item.Id, label: item.Name })
              })
            }
            if (type == 3) {
              that.OptionsArea = []
              response.data.List.filter((item, i) => {
                that.OptionsArea.push({ value: item.Id, label: item.Name })
              })
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristSuppliersClassification: function (ptype, producttype, brand, productname) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var bufproducttype = producttype
      if(bufproducttype == '备用镜片'){
        bufproducttype = '镜片'
      }
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        ptype: ptype,
        producttype: bufproducttype,
        brand: brand,
        productname: productname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristSuppliersClassification, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            // 镜架
            if(producttype == '镜架' && ptype == 1) {
              that.FrameBrandOptions = []
              response.data.List.filter((item, i) => {
                that.FrameBrandOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(producttype == '镜架' && ptype == 2) {
              that.FrameProductNameOptions = []
              response.data.List.filter((item, i) => {
                that.FrameProductNameOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(producttype == '镜架' && ptype == 3) {
              that.FrameSpecificationsOptions = []
              response.data.List.filter((item, i) => {
                that.FrameSpecificationsOptions.push({ value: item.Name, label: item.Name })
              })
            }
            // 镜片
            if(producttype == '镜片' && ptype == 1) {
              that.LensBrandOptions = []
              response.data.List.filter((item, i) => {
                that.LensBrandOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(producttype == '镜片' && ptype == 2) {
              that.LensProductNameOptions = []
              response.data.List.filter((item, i) => {
                that.LensProductNameOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(producttype == '镜片' && ptype == 3) {
              that.LensSpecificationsOptions = []
              response.data.List.filter((item, i) => {
                that.LensSpecificationsOptions.push({ value: item.Name, label: item.Name })
              })
            }
            // 备用镜片
            if(producttype == '备用镜片' && ptype == 1) {
              that.LensReserveBrandOptions = []
              response.data.List.filter((item, i) => {
                that.LensReserveBrandOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(producttype == '备用镜片' && ptype == 2) {
              that.LensReserveProductNameOptions = []
              response.data.List.filter((item, i) => {
                that.LensReserveProductNameOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(producttype == '备用镜片' && ptype == 3) {
              that.LensReserveSpecificationsOptions = []
              response.data.List.filter((item, i) => {
                that.LensReserveSpecificationsOptions.push({ value: item.Name, label: item.Name })
              })
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristProductinPrice: function (producttype, brand, productname, specifications) {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var bufproducttype = producttype
      if(bufproducttype == '备用镜片'){
        bufproducttype = '镜片'
      }
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        producttype: bufproducttype,
        brand: brand,
        productname: productname,
        specifications: specifications
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristProductinPrice, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            // 镜架
            if(producttype == '镜架') {
              that.myForm.frameprice = response.data.Price
              that.myForm.frameretailprice = response.data.Retailprice
              if(that.SubRule_Optometrist_ShowPrice){
                //老板权限
                that.myForm.framepriceForDisplay = ""+that.myForm.frameprice+"(零售价:"+that.myForm.frameretailprice+")"
              } else {
                //店员权限
                that.myForm.framepriceForDisplay = "零售价:"+that.myForm.frameretailprice
              }
            }
            // 镜片
            if(producttype == '镜片') {
              that.myForm.lensprice = response.data.Price
              that.myForm.lensretailprice = response.data.Retailprice
              if(that.SubRule_Optometrist_ShowPrice){
                //老板权限
                that.myForm.lenspriceForDisplay = ""+that.myForm.lensprice+"(零售价:"+that.myForm.lensretailprice+")"
              } else {
                //店员权限
                that.myForm.lenspriceForDisplay = "零售价:"+that.myForm.lensretailprice
              }
            }
            // 备用镜片
            if(producttype == '备用镜片') {
              that.myForm.lensReserveprice = response.data.Price
              that.myForm.lensReserveretailprice = response.data.Retailprice
              if(that.SubRule_Optometrist_ShowPrice){
                //老板权限
                that.myForm.lensReservepriceForDisplay = ""+that.myForm.lensReserveprice+"(零售价:"+that.myForm.lensReserveretailprice+")"
              } else {
                //店员权限
                that.myForm.lensReservepriceForDisplay = "零售价:"+that.myForm.lensReserveretailprice
              }
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    },
    apiGetOptometristPrescriptionsLastAddress: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristPrescriptionsLastAddress, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            if(response.data.Provinces > 0){
              that.myForm.provinces = response.data.Provinces.toString()
              that.apigetregionlist(2, that.myForm.provinces)
            }
            if(response.data.Cities > 0){
              that.myForm.cities = response.data.Cities.toString()
              that.apigetregionlist(3, that.myForm.cities)
            }
            if( response.data.Districts > 0){
              that.myForm.districts = response.data.Districts.toString()
            }
            that.myForm.consignee = response.data.Consignee
            that.myForm.phone = response.data.Phone
            that.myForm.consigneeaddress = response.data.Consigneeaddress
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristUrgentFee: function () {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        provinces: that.myForm.provinces
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristUrgentFee, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.myForm.urgentnum = '1'
            that.myForm.urgentprice = response.data.Price
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    },
    apiGetOptometristProcessCost: function () {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        framebrand: that.myForm.framebrand,
        lensbrand: that.myForm.lensbrand,
        lensproductname: that.myForm.lensproductname,
        lensspecifications: that.myForm.lensspecifications
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristProcessCost, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.myForm.processcostnum = Number(that.myForm.lensnum) + Number(that.myForm.lensReservenum)
            that.myForm.processcostprice = response.data.Price
            that.myForm.insuranceprice = response.data.InsurancePrice
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    },
    apiAddOptometristPrescriptions: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.myForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddOptometristPrescriptions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.myForm = Vue.prototype.CloneObj(that.myFormBack)
            that.$emit('triggerFunc', '')
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristPrescriptions: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.myForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristPrescriptions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristPrescriptionsInfo: function (orderid) {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristPrescriptionsInfo, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.myForm.username = response.data.Username
            that.myForm.sex = response.data.Sex
            that.myForm.age = response.data.Age
            that.myForm.glassestime = response.data.Glassestime
            that.myForm.consignee = response.data.Consignee
            that.myForm.phone = response.data.Phone
            that.myForm.provinces = response.data.Provinces.toString()
            that.myForm.cities = response.data.Cities.toString()
            that.myForm.districts = response.data.Districts.toString()
            that.apigetregionlist(2, that.myForm.provinces)
            that.apigetregionlist(3, that.myForm.cities)
            that.myForm.consigneeaddress = response.data.Consigneeaddress
            that.myForm.eyedegreefarright = response.data.Eyedegreefarright
            that.myForm.eyedegreefarleft = response.data.Eyedegreefarleft
            that.myForm.eyedegreenearright = response.data.Eyedegreenearright
            that.myForm.eyedegreenearleft = response.data.Eyedegreenearleft
            that.myForm.columnmirrorfarright = response.data.Columnmirrorfarright
            that.myForm.columnmirrorfarleft = response.data.Columnmirrorfarleft
            that.myForm.columnmirrornearright = response.data.Columnmirrornearright
            that.myForm.columnmirrornearleft = response.data.Columnmirrornearleft
            that.myForm.axialfarright = response.data.Axialfarright
            that.myForm.axialfarleft = response.data.Axialfarleft
            that.myForm.axialnearright = response.data.Axialnearright
            that.myForm.axialnearleft = response.data.Axialnearleft
            that.myForm.correctdegreefarright = response.data.Correctdegreefarright
            that.myForm.correctdegreefarleft = response.data.Correctdegreefarleft
            that.myForm.correctdegreenearright = response.data.Correctdegreenearright
            that.myForm.correctdegreenearleft = response.data.Correctdegreenearleft
            that.myForm.interpupillaryfarright = response.data.Interpupillaryfarright
            that.myForm.interpupillaryfarleft = response.data.Interpupillaryfarleft
            that.myForm.interpupillarynearright = response.data.Interpupillarynearright
            that.myForm.interpupillarynearleft = response.data.Interpupillarynearleft
            that.myForm.pupilheightfarright = response.data.Pupilheightfarright
            that.myForm.pupilheightfarleft = response.data.Pupilheightfarleft
            that.myForm.pupilheightnearright = response.data.Pupilheightnearright
            that.myForm.pupilheightnearleft = response.data.Pupilheightnearleft
            that.myForm.isspecialized = response.data.Isspecialized
            that.myForm.channel = response.data.Channel
            that.myForm.addtype = String(response.data.Addtype)
            that.myForm.optometrytime = response.data.Optometrytime
            that.myForm.remarks = response.data.Remarks
            that.myForm.optometryname = response.data.Optometryname
            //////// 商品信息
            // 镜架
            that.myForm.framebrand = response.data.Framebrand
            that.myForm.frameproductname = response.data.Frameproductname
            that.myForm.framespecifications = response.data.Framespecifications
            that.myForm.framenum = response.data.Framenum
            that.myForm.frameprice = response.data.Frameprice
            that.myForm.frameretailprice = response.data.FrameRetailprice
            // 镜片
            that.myForm.lensbrand = response.data.Lensbrand
            that.myForm.lensproductname = response.data.Lensproductname
            that.myForm.lensspecifications = response.data.Lensspecifications
            that.myForm.lensnum = response.data.Lensnum
            that.myForm.lensprice = response.data.Lensprice
            that.myForm.lensretailprice = response.data.LensRetailprice
            // 备用镜片
            that.myForm.lensReservebrand = response.data.LensReservebrand
            that.myForm.lensReserveproductname = response.data.LensReserveproductname
            that.myForm.lensReservespecifications = response.data.LensReservespecifications
            that.myForm.lensReservenum = response.data.LensReservenum
            that.myForm.lensReserveprice = response.data.LensReserveprice
            that.myForm.lensReserveretailprice = response.data.LensReserveRetailprice
            // 加工费
            that.myForm.processcostname = response.data.Processcostname
            that.myForm.processcostnum = response.data.Processcostnum
            that.myForm.processcostprice = response.data.Processcostprice
            // 加急费
            that.myForm.isurgent = response.data.Isurgent
            that.myForm.urgentnum = response.data.Urgentnum
            that.myForm.urgentprice = response.data.Urgentprice
            // 保险费
            that.myForm.insurancename = response.data.Insurancename
            that.myForm.insurancenum = response.data.Insurancenum
            that.myForm.insuranceprice = response.data.Insuranceprice
            //总价
            that.myForm.amount = response.data.Amount
            that.myForm.amountretail = response.data.AmountRetail

            if(that.SubRule_Optometrist_ShowPrice){
              //老板权限
              that.myForm.framepriceForDisplay = ""+that.myForm.frameprice+"(零售价:"+that.myForm.frameretailprice+")"
            } else {
              //店员权限
              that.myForm.framepriceForDisplay = "零售价:"+that.myForm.frameretailprice
            }
            if(that.SubRule_Optometrist_ShowPrice){
              //老板权限
              that.myForm.lenspriceForDisplay = ""+that.myForm.lensprice+"(零售价:"+that.myForm.lensretailprice+")"
            } else {
              //店员权限
              that.myForm.lenspriceForDisplay = "零售价:"+that.myForm.lensretailprice
            }
            if(that.SubRule_Optometrist_ShowPrice){
              //老板权限
              that.myForm.lensReservepriceForDisplay = ""+that.myForm.lensReserveprice+"(零售价:"+that.myForm.lensReserveretailprice+")"
            } else {
              //店员权限
              that.myForm.lensReservepriceForDisplay = "零售价:"+that.myForm.lensReserveretailprice
            }

            // 给选择器准备默认数据
            that.apiGetOptometristSuppliersClassification(2,"镜架",that.myForm.framebrand,"")
            that.apiGetOptometristSuppliersClassification(3,"镜架",that.myForm.framebrand,that.myForm.frameproductname)
            that.apiGetOptometristSuppliersClassification(2,"镜片",that.myForm.lensbrand,"")
            that.apiGetOptometristSuppliersClassification(3,"镜片",that.myForm.lensbrand,that.myForm.lensproductname)
            that.apiGetOptometristSuppliersClassification(2,"备用镜片",that.myForm.lensReservebrand,"")
            that.apiGetOptometristSuppliersClassification(3,"备用镜片",that.myForm.lensReservebrand,that.myForm.lensReserveproductname)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    },
  },
};
</script>

<style>
{mso-displayed-decimal-separator:"\.";
 mso-displayed-thousand-separator:"\,";}
@page
 {
 mso-header-data:"";
 mso-footer-data:"";
 margin:1in 0.75in 1in 0.75in;
 mso-header-margin:0.5in;
 mso-footer-margin:0.5in;
 mso-page-orientation:Portrait;
 }
tr
 {mso-height-source:auto;
 mso-ruby-visibility:none;}
col
 {mso-width-source:auto;
 mso-ruby-visibility:none;}
br
 {mso-data-placement:same-cell;}
ruby
 {ruby-align:left;}
input{
     border: none;
     outline:medium;
     text-align:center;
     overflow: hidden;
     height: 100%;
     width: 95%;
  }
.addbutton{
  position: fixed;
  top: 50vh;
  right: 60px;
}
.style0
 {
 mso-number-format:General;
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border:none;
 mso-protection:locked visible;
 mso-style-name:Normal;
 mso-style-id:0;}
.font0
 {
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font1
 {
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif"; }
.font2
 {
 color:#000000;
 font-size:12pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font3
 {
 color:#00B0F0;
 font-size:18pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font4
 {
 color:#000000;
 font-size:14pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font5
 {
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font6
 {
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font7
 {
 color:#00B0F0;
 font-size:14pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font8
 {
 color:#000000;
 font-size:14pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font9
 {
 color:#3F3F76;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font10
 {
 color:#9C0006;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font11
 {
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font12
 {
 color:#0000FF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 text-decoration:underline;
 font-family:"宋体","sans-serif"; }
.font13
 {
 color:#800080;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 text-decoration:underline;
 font-family:"宋体","sans-serif"; }
.font14
 {
 color:#1F497D;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font15
 {
 color:#FF0000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font16
 {
 color:#1F497D;
 font-size:18pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font17
 {
 color:#7F7F7F;
 font-size:11pt;
 font-weight:400;
 font-style:italic;
 font-family:"宋体","sans-serif"; }
.font18
 {
 color:#1F497D;
 font-size:15pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font19
 {
 color:#1F497D;
 font-size:13pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font20
 {
 color:#3F3F3F;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font21
 {
 color:#FA7D00;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font22
 {
 color:#FFFFFF;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font23
 {
 color:#FA7D00;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font24
 {
 color:#000000;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font25
 {
 color:#006100;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
.font26
 {
 color:#9C6500;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif"; }
td
 {mso-style-parent:style0;
 mso-number-format:General;
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border:none;
 mso-protection:locked visible;
 mso-ignore:padding;}
.style0
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"Normal";
 }
.style1
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style2
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style3
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style4
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style5
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style6
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style7
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style8
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style9
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style10
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style11
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style12
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style13
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.style14
 {
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 }
.x15
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 }
.style16
 {
 mso-number-format:"0%";
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"Percent";
 }
.style17
 {
 mso-number-format:"_ \0022¥\0022* \#\,\#\#0\.00_ \;_ \0022¥\0022* -\#\,\#\#0\.00_ \;_ \0022¥\0022* \0022-\0022??_ \;_ \@_ ";
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"Currency";
 }
.style18
 {
 mso-number-format:"_ \0022¥\0022* \#\,\#\#0_ \;_ \0022¥\0022* -\#\,\#\#0_ \;_ \0022¥\0022* \0022-\0022_ \;_ \@_ ";
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"Currency [0]";
 }
.style19
 {
 mso-number-format:"_ * \#\,\#\#0\.00_ \;_ * -\#\,\#\#0\.00_ \;_ * \0022-\0022??_ \;_ \@_ ";
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"Comma";
 }
.style20
 {
 mso-number-format:"_ * \#\,\#\#0_ \;_ * -\#\,\#\#0_ \;_ * \0022-\0022_ \;_ \@_ ";
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"Arial","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"Comma [0]";
 }
.style21
 {
 mso-number-format:"_ \0022￥\0022* \#\,\#\#0_ \;_ \0022￥\0022* \\-\#\,\#\#0_ \;_ \0022￥\0022* \0022-\0022_ \;_ \@_ ";
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"货币[0]";
 }
.style22
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#EBF1DE;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"20% - 强调文字颜色 3";
 }
.style23
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#FFCC99;
 mso-pattern:auto none;
 color:#3F3F76;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid #7F7F7F;
 border-right:1px solid #7F7F7F;
 border-bottom:1px solid #7F7F7F;
 border-left:1px solid #7F7F7F;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"输入";
 }
.style24
 {
 mso-number-format:"_ \0022￥\0022* \#\,\#\#0\.00_ \;_ \0022￥\0022* \\-\#\,\#\#0\.00_ \;_ \0022￥\0022* \0022-\0022??_ \;_ \@_ ";
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"货币";
 }
.style25
 {
 mso-number-format:"_ * \#\,\#\#0_ \;_ * \\-\#\,\#\#0_ \;_ * \0022-\0022_ \;_ \@_ ";
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"千位分隔[0]";
 }
.style26
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#D7E4BD;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"40% - 强调文字颜色 3";
 }
.style27
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#FFC7CE;
 mso-pattern:auto none;
 color:#9C0006;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"差";
 }
.style28
 {
 mso-number-format:"_ * \#\,\#\#0\.00_ \;_ * \\-\#\,\#\#0\.00_ \;_ * \0022-\0022??_ \;_ \@_ ";
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"千位分隔";
 }
.style29
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#C3D69B;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"60% - 强调文字颜色 3";
 }
.style30
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#0000FF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 text-decoration:underline;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"超链接";
 }
.style31
 {
 mso-number-format:"0%";
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"百分比";
 }
.style32
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#800080;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 text-decoration:underline;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"已访问的超链接";
 }
.style33
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#FFFFCC;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid #B2B2B2;
 border-right:1px solid #B2B2B2;
 border-bottom:1px solid #B2B2B2;
 border-left:1px solid #B2B2B2;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"注释";
 }
.style34
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#D99694;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"60% - 强调文字颜色 2";
 }
.style35
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#1F497D;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"标题 4";
 }
.style36
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#FF0000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"警告文本";
 }
.style37
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#1F497D;
 font-size:18pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"标题";
 }
.style38
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#7F7F7F;
 font-size:11pt;
 font-weight:400;
 font-style:italic;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"解释性文本";
 }
.style39
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#1F497D;
 font-size:15pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:none;
 border-right:none;
 border-bottom:2px solid #4F81BD;
 border-left:none;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"标题 1";
 }
.style40
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#1F497D;
 font-size:13pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:none;
 border-right:none;
 border-bottom:2px solid #4F81BD;
 border-left:none;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"标题 2";
 }
.style41
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#95B3D7;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"60% - 强调文字颜色 1";
 }
.style42
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#1F497D;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:none;
 border-right:none;
 border-bottom:2px solid #A7C0DE;
 border-left:none;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"标题 3";
 }
.style43
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#B3A2C7;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"60% - 强调文字颜色 4";
 }
.style44
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#F2F2F2;
 mso-pattern:auto none;
 color:#3F3F3F;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid #3F3F3F;
 border-right:1px solid #3F3F3F;
 border-bottom:1px solid #3F3F3F;
 border-left:1px solid #3F3F3F;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"输出";
 }
.style45
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#F2F2F2;
 mso-pattern:auto none;
 color:#FA7D00;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid #7F7F7F;
 border-right:1px solid #7F7F7F;
 border-bottom:1px solid #7F7F7F;
 border-left:1px solid #7F7F7F;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"计算";
 }
.style46
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#A5A5A5;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:4px double #3F3F3F;
 border-right:4px double #3F3F3F;
 border-bottom:4px double #3F3F3F;
 border-left:4px double #3F3F3F;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"检查单元格";
 }
.style47
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#FDEADA;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"20% - 强调文字颜色 6";
 }
.style48
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#C0504D;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"强调文字颜色 2";
 }
.style49
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#FA7D00;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:none;
 border-right:none;
 border-bottom:4px double #FF8001;
 border-left:none;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"链接单元格";
 }
.style50
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:11pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid #4F81BD;
 border-right:none;
 border-bottom:4px double #4F81BD;
 border-left:none;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 mso-style-name:"汇总";
 }
.style51
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#C6EFCE;
 mso-pattern:auto none;
 color:#006100;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"好";
 }
.style52
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#FFEB9C;
 mso-pattern:auto none;
 color:#9C6500;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"适中";
 }
.style53
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#DBEEF4;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"20% - 强调文字颜色 5";
 }
.style54
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#4F81BD;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"强调文字颜色 1";
 }
.style55
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#DCE6F2;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"20% - 强调文字颜色 1";
 }
.style56
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#B9CDE5;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"40% - 强调文字颜色 1";
 }
.style57
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#F2DCDB;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"20% - 强调文字颜色 2";
 }
.style58
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#E6B9B8;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"40% - 强调文字颜色 2";
 }
.style59
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#9BBB59;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"强调文字颜色 3";
 }
.style60
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#8064A2;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"强调文字颜色 4";
 }
.style61
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#E6E0EC;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"20% - 强调文字颜色 4";
 }
.style62
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#CCC1DA;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"40% - 强调文字颜色 4";
 }
.style63
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#4BACC6;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"强调文字颜色 5";
 }
.style64
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#B7DEE8;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"40% - 强调文字颜色 5";
 }
.style65
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#93CDDD;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"60% - 强调文字颜色 5";
 }
.style66
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#F79646;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"强调文字颜色 6";
 }
.style67
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#FCD5B5;
 mso-pattern:auto none;
 color:#000000;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"40% - 强调文字颜色 6";
 }
.style68
 {
 text-align:general;
 vertical-align:bottom;
 white-space:nowrap;
 background:#FAC090;
 mso-pattern:auto none;
 color:#FFFFFF;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 mso-style-name:"60% - 强调文字颜色 6";
 }
.x69
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:12pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 }
.x70
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#00B0F0;
 font-size:18pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x71
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 font-size:14pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x72
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x73
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:left;
 vertical-align:middle;
 white-space:normal;word-wrap:break-word;
 background:white;
 mso-pattern:auto;
 font-size:14pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x74
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 font-size:11pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x75
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 font-size:14pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x76
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#00B0F0;
 font-size:14pt;
 font-weight:700;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x77
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:normal;word-wrap:break-word;
 background:#F2F2F2;
 mso-pattern:auto none;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x78
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:normal;word-wrap:break-word;
 background:#F2F2F2;
 mso-pattern:auto none;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x79
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:nowrap;
 background:#F2F2F2;
 mso-pattern:auto none;
 font-size:10pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 border-top:1px solid windowtext;
 border-right:1px solid windowtext;
 border-bottom:1px solid windowtext;
 border-left:1px solid windowtext;
 mso-diagonal-down:none;
 mso-diagonal-up:none;
 mso-protection:locked visible;
 }
.x80
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:general;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:14pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 }
.x81
 {
 mso-style-parent:style0;
 mso-number-format:General;
 text-align:center;
 vertical-align:middle;
 white-space:nowrap;
 background:white;
 mso-pattern:auto;
 color:#000000;
 font-size:14pt;
 font-weight:400;
 font-style:normal;
 font-family:"宋体","sans-serif";
 mso-protection:locked visible;
 }
</style>
